import { EHeatingType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectHeatingTypeFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const HeatingTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectHeatingTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleHeatingTypesChange = useCallback(
    (newValue: NonEmptyArray<EHeatingType> | null) => {
      onChange({ action: 'setHeatingTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleHeatingTypesChange} />
    </AdvancedFilterRow>
  );
};
